import { z } from "zod";
import { BlockBaseSchema } from "blocks/types/base";
import { blockType } from "./constants";
import { BlockIdPlaceholder } from "utils/regex";
import { WidthSchema } from "../__shared__/components/WidthField/schema";
import { AlignmentSchema } from "../__shared__/components/AlignmentField/schema";

export const ZapbotBlockSchema = BlockBaseSchema.extend({
  type: z.literal(blockType),
  config: z
    .object({
      id: z.string().cuid().or(z.string().regex(BlockIdPlaceholder)).optional(),
      zapbotId: z.string().optional(),
      testBotButtonCopy: z.string().optional(),
      style: z
        .object({
          width: WidthSchema.optional(),
          alignment: AlignmentSchema.optional(),
        })
        .optional(),
    })
    .default({}),
}).openapi({ ref: "ZapbotBlock" });
